import {ADD_TO_CART_ACTION, ADD_TO_CART_ACTION_LOADER, CART_ACTION, CART_ACTION_LOADER,CLEAR_CART_MESSAGE} from "../type"

const initialState = {
  loader: false,
  items: [],
  cart_count: 0,
  cart: null,
    error: null,
  successMessage: null,
};

const CartReducer = (state = initialState, action) => {
  switch (action.type) {

    case CART_ACTION_LOADER:
    case ADD_TO_CART_ACTION_LOADER:
      return {
        ...state,
        loader: action.loader,
      };

    case CART_ACTION:
      
      return {
        ...state,
        items: action.items,
        cart_count: action.cart_count,
        cart: action.cart || null,
        error: action.error || null,
        successMessage: action.message || null,
      };

    case ADD_TO_CART_ACTION:
      return {
        ...state,
        items: action.items,
        cart_count: action.cart_count,
        cart: action.cart || state.cart,
         error: action.error || null,
        successMessage: action.message || null,
      };
case CLEAR_CART_MESSAGE:
      return {
        ...state,
        error: null,
        successMessage: null,
      };
    default:
      return state;
  }
}

export default CartReducer;
